import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, SpacingStack, TextV2, styled, DialogV2 } from '@withjoy/joykit';
import type { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledGroupRow = styled(Flex)``;

export const StyledButtonsContainer = styled(Flex)``;

export const StyledStack = styled(SpacingStack)``;

const groupRowStyles: CSSObject = {
  flexWrap: ['wrap', 'wrap', 'nowrap'],
  ['> div']: {
    width: '100%',
  },
  columnGap: '1.5rem',
};

const buttonsContainerStyles: StyleSystemProps = {
  columnGap: '0.5rem',
  rowGap: '0.5rems',
  width: '100%',
  flexDirection: ['column-reverse', 'row'],
};

const stackStyles: CSSObject = {
  ['> p:nth-child(2)']: {
    marginTop: '1rem',
  },
};

export const StyledRequiredFieldText = styled(TextV2)``;
const requiredFieldTextStyles: StyleSystemProps = {
  marginTop: [6, 6, 'unset'],
};

export const StyledAddressFormContent = styled(Flex)``;
const addressFormContentStyles: StyleSystemProps = {
  flexDirection: 'column',
  height: ['100vh', 'unset', 'unset'],
  width: '100%',
};

export const StyledDialogV2 = styled(DialogV2)``;
const dialogV2BodyStyles: StyleSystemProps = {
  height: ['unset', '640px', '640px'],
  position: 'relative',
  overflow: 'auto',
};

export const learnMoreButtonOverrides = {
  Root: {
    props: {
      fontWeight: 400,
      marginBottom: 1,
      fontSize: pxToRem(15),
      height: 'fit-content',
      padding: 0,
      color: 'mono12',
      _hover: {
        color: 'mono10',
      },
      _active: {
        color: 'mono14',
      },
    },
  },
};

export const styles = {
  groupRow: groupRowStyles,
  buttonsContainer: buttonsContainerStyles,
  stack: stackStyles,
  requiredFieldText: requiredFieldTextStyles,
  addressFormContent: addressFormContentStyles,
  dialogV2Body: dialogV2BodyStyles,
};
